import { GlobalAdmin } from "coolremote-sdk";
import { Thunk, thunk } from "easy-peasy";
import {
  IQueueJobDetails,
  IQueueJobsPage,
  IQueueSchedulersPage,
  IQueueSummary,
  IRedisDetails,
  QueueJobStatus
} from "./Queues.types";

/** Queue dashboard data layer (CM-844): a read-only view of the BullMQ queues. */
export interface IQueuesModel {
  getQueues: Thunk<IQueuesModel, void, any, any, Promise<IQueueSummary[]>>;
  getSchedulers: Thunk<
    IQueuesModel,
    { queueId: string; page: number; pageSize: number },
    any,
    any,
    Promise<IQueueSchedulersPage>
  >;
  getRedisInfo: Thunk<IQueuesModel, void, any, any, Promise<IRedisDetails>>;
  getJobs: Thunk<
    IQueuesModel,
    { queueId: string; status: QueueJobStatus; page: number; pageSize: number },
    any,
    any,
    Promise<IQueueJobsPage>
  >;
  getJob: Thunk<
    IQueuesModel,
    { queueId: string; jobId: string },
    any,
    any,
    Promise<IQueueJobDetails>
  >;
}

export const queuesModel: IQueuesModel = {
  getQueues: thunk(async () => {
    const data = await GlobalAdmin.getQueues();

    return data?.queues || [];
  }),

  // The API pages from 1, the table from 0.
  getSchedulers: thunk(async (_actions, { queueId, page, pageSize }) => {
    const data = await GlobalAdmin.getQueueSchedulers(queueId, { pageNum: page + 1, pageSize });

    return { schedulers: data?.schedulers || [], totalCount: data?.totalCount || 0 };
  }),

  getRedisInfo: thunk(async () => {
    const data = await GlobalAdmin.getQueuesRedisInfo();

    return { info: data?.info || {}, sections: data?.sections || [], dbSize: data?.dbSize ?? null };
  }),

  // The API pages from 1, the table from 0.
  getJobs: thunk(async (_actions, { queueId, status, page, pageSize }) => {
    return GlobalAdmin.getQueueJobs(queueId, { status, pageNum: page + 1, pageSize });
  }),

  getJob: thunk(async (_actions, { queueId, jobId }) => {
    const data = await GlobalAdmin.getQueueJob(queueId, jobId);

    return data.job;
  })
};
